import { createContext } from "react";
import type { Publication } from "@rowan/prisma";

type UserPublicationsContextType = {
  publications?: Publication[];
  archivedPublications?: Publication[];
  publicationsBySlug?: Record<string, Publication>;
  isLoading?: boolean;
  isFetched?: boolean;
};

export const UserPublicationsContext =
  createContext<UserPublicationsContextType>({} as UserPublicationsContextType);
